export default "__VITE_ASSET__JCtvBLZ2__"